/**
 * Created by joe on 16/9/6.
 */

module.exports = require('./lib/DragScroll');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dragscroll/index.js
// module id = 522
// module chunks = 1